import { ChangeEvent } from 'react';
import { useTheme } from '../contexts/ThemeContext';
import { useLanguage } from '../contexts/LanguageContext';
import { translate } from '../i18n';
import type { ThemeMode } from '../styles/theme.css';

const optionLabels: Record<ThemeMode, 'themeLight' | 'themeDark' | 'themeSystem'> = {
  light: 'themeLight',
  dark: 'themeDark',
  system: 'themeSystem'
};

const ThemeSwitcher = () => {
  const { locale } = useLanguage();
  const { mode, setMode, options } = useTheme();

  const handleChange = (event: ChangeEvent<HTMLSelectElement>) => {
    setMode(event.target.value as ThemeMode);
  };

  return (
    <label className="theme-switcher">
      <span>{translate(locale, 'themeLabel')}</span>
      <select value={mode} onChange={handleChange} aria-label={translate(locale, 'themeLabel')}>
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {translate(locale, optionLabels[option.value])}
          </option>
        ))}
      </select>
    </label>
  );
};

export default ThemeSwitcher;
